import React, { useEffect, useRef, useState } from 'react';
import anime from 'animejs';

// Animated counter that triggers when scrolled into view.
const Counter = ({ to = 0, suffix = '', duration = 1600, className = '' }) => {
    const ref = useRef(null);
    const [val, setVal] = useState(0);
    const startedRef = useRef(false);

    useEffect(() => {
        const el = ref.current;
        if (!el) return;
        const io = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting && !startedRef.current) {
                        startedRef.current = true;
                        const obj = { v: 0 };
                        anime({
                            targets: obj,
                            v: to,
                            duration,
                            easing: 'easeOutCubic',
                            round: 1,
                            update: () => setVal(obj.v),
                        });
                        io.unobserve(el);
                    }
                });
            },
            { threshold: 0.4 }
        );
        io.observe(el);
        return () => io.disconnect();
    }, [to, duration]);

    return (
        <span ref={ref} className={className}>
            {val}
            {suffix}
        </span>
    );
};

export default Counter;
